import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const useNodeAncestorPath = (taxonomyId: string | undefined, nodeId: string | undefined) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading } = useQuery({
    queryKey: ['taxonomy.nodeAncestorPath', tenantId, taxonomyId, nodeId],
    queryFn: async () => {
      const response = await api.taxonomy.getNodeAncestors(tenantId, taxonomyId!, nodeId!);
      return response.data.ancestors.map(ancestor => ancestor.id).reverse();
    },
    enabled: Boolean(tenantId) && Boolean(taxonomyId) && Boolean(nodeId),
    retry: false,
  });

  return { ancestorPath: data, isLoading };
};
